import React, { createContext, useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';

export const ShoppingCartContext = createContext();

export const ShoppingCartProvider = ({ children }) => {
    const [shoppingCart, setShoppingCart] = useState(null);
    const [orderType, setOrderType] = useState(null);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [categoriesOpen, setCategoriesOpen] = useState(false);

    const getShoppingCart = () => shoppingCart;
    const shopping_cart_session_id = 'shoppingcart';
    const hasHydrated = useRef(false);
    const user_session_id = 'user';

    useEffect(() => {
        if (!hasHydrated.current) {
            const storedCart = localStorage.getItem(shopping_cart_session_id);
            if (storedCart) {
                setShoppingCart(JSON.parse(storedCart));
            }
            hasHydrated.current = true;
        }
    }, []);

    useEffect(() => {
        if (shoppingCart && shoppingCart.items?.length > 0) {
            localStorage.setItem(shopping_cart_session_id, JSON.stringify(shoppingCart));
        }
    }, [shoppingCart]);

    const clearCart = () => {
        localStorage.removeItem(shopping_cart_session_id);
        setShoppingCart(null);
    };

    const getCookie = () => {
        let usr = Cookies.get(user_session_id);
        try {
            if (usr) {
                const jsonObject = JSON.parse(usr);
                return jsonObject;
            }
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <ShoppingCartContext.Provider value={{ shoppingCart, setShoppingCart, getShoppingCart, clearCart, orderType, setOrderType, isDropdownOpen, setDropdownOpen, categoriesOpen, setCategoriesOpen, getCookie }}>
            {children}
        </ShoppingCartContext.Provider>
    );
};